import axios from "../../utils/axios";
import { isImage } from "../../utils/image";

async function getShopsByEmail(email) {
  const res = await axios.get(
    `/public/shops-by-email/${email}?source=admin-panel`,
  );
  if (res.data) return res.data;
}

async function shopUserById(userId) {
  return await axios.get(`single/shop-user/${userId}`);
}

async function upload({ file, imgSizes }) {
  const formData = new FormData();
  formData.append("file", file);
  if (imgSizes?.length && isImage(file))
    formData.append("imgSizes", imgSizes.join(","));

  const res = await axios.post(
    `public/upload-file?api_key=${process.env.REACT_APP_API_KEY}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return res.data;
}

const publicService = {
  getShopsByEmail,
  shopUserById,
  upload,
};

export default publicService;
